export const templateStatusMessages = {
  active: { id: 'template-status.active', defaultMessage: 'Active' },
  archived: { id: 'template-status.archived', defaultMessage: 'Archived' },
};

export const statusOptions = [
  { value: 'active', label: templateStatusMessages.active },
  { value: 'archived', label: templateStatusMessages.archived },
];
